import { useEffect } from "react";

import { SessionStorageConstants } from "../../constants";
import { safeSessionStorage } from "../storage";

export const useShowBrowserConfirmationDialog = (): void => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent): void => {
      // Checks createNewDealJourney data, we may want to check different items in the future
      const raw = safeSessionStorage.getItem(SessionStorageConstants.Deal_Journey_Data);
      if (!raw) return;

      event.preventDefault();
      // eslint-disable-next-line no-param-reassign
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);
};
